module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FRWvXl/tc-custom/9781488092237.jpg?1705539641631",
      "alt": "This image is the cover for the book Stranger in His Bed, The Masters of Texas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stranger in His Bed, The Masters of Texas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("He says he’s her husband. But with her memory shattered, can she trust him—and give in to temptation? “A scrumptious and sensual story for romance fans!” —"), _c('i', [_vm._v("Fresh Fiction")])]), _c('br'), _c('br'), _vm._v("Victoria Masters remembers nothing after the accident that stole her past, not even her name. Now she’s living in a billionaire rancher’s palatial home and finding this sensual stranger impossible to resist. He says he’s her husband, but why does she get the sense he’s holding back? "), _c('br'), _c('br'), _vm._v("Now, as a powerful desire leads her into Wade’s bed, a surprise she’ll never forget is in store . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lauren Canan\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0